import { EImportSectionsTarget } from '@constants';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { ImportSectionDrawer } from './ImportSectionDrawer';
import { OnImportOptions } from './types';
import { useImportSectionDrawer } from './useImportSectionDrawer';

import { Icon } from '@/components/Icon';
import { useLocalCourse, useMutateSection, useProfile } from '@/store';

type ImportSectionProps = {
  target?: EImportSectionsTarget;
  fetchOnlyParentsCourses?: boolean;
};

export const ImportSection: React.FC<ImportSectionProps> = ({
  target = EImportSectionsTarget.SECTIONS,
  fetchOnlyParentsCourses
}) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const { openDrawer } = useImportSectionDrawer();
  const { course } = useLocalCourse();
  const { importSections, isImporting } = useMutateSection();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course || !isManager) return null;

  const handleImportForManager = ({ sections, isSyncedToParent, onSuccess }: OnImportOptions) => {
    importSections(
      {
        courseId: course._id,
        sections: sections.map(({ _id, activities }) => ({
          _id,
          activities: activities?.map(activity => activity._id) ?? []
        })),
        target,
        isSyncedToParent
      },
      { onSuccess }
    );
  };

  return (
    <>
      <Button
        size="middle"
        type="primary"
        onClick={() => openDrawer(handleImportForManager)}
        icon={<Icon i="ImportExport" />}>
        {t('IMPORT_SECTION')}
      </Button>
      <ImportSectionDrawer
        target={target}
        fetchOnlyParentsCourses={fetchOnlyParentsCourses}
        isImporting={isImporting}
      />
    </>
  );
};
